import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injector } from '@angular/core';
import { ApplicationInsightsService } from './framework/logging/application-insights.service';

export class ErrorHandlerImplementation implements ErrorHandler {
  constructor(private injector: Injector) { }

  handleError(error: Error): void {
    const applicationInsightsService = this.injector.get(ApplicationInsightsService);
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (error instanceof HttpErrorResponse) {
      if (error.status === 0 && error.statusText === 'Unknown Error') {
        console.warn('Suppressing Application Insights logging for Http failure response: 0 Unknown Error', error);
        console.error(error);
        return;
      }
      if (error.status === 500 && error.statusText === 'OK') {
        console.warn('Suppressing Application Insights logging for Http failure response: 500 OK', error);
        console.error(error);
        return;
      }
      if (error.status === 403 && error.statusText === 'OK') {
        console.warn('Suppressing Application Insights logging for Http failure response: 403 OK', error);
        console.error(error);
        return;
      }
    }

    if (error.message && error.message.includes('timeout')) {
      console.warn('Suppressing Application Insights logging for timeout error', error);
      console.error(error);
      return;
    }

    // Check for network/load errors (Failed to fetch, Load failed)
    if (error.message === 'Load failed' || error.message === 'Failed to fetch' || (error instanceof TypeError && (error.message === 'Load failed' || error.message === 'Failed to fetch'))) {
      console.warn('Suppressing Application Insights logging for network/load errors', error);
      console.error(error);
      return;
    }

    if (error.message === 'Maximum call stack size exceeded') {
      console.warn('Suppressing Application Insights logging for "Maximum call stack size exceeded" error', error);
      console.error(error);
      return;
    }

    if (chunkFailedMessage.test(error.message)) {
      if (applicationInsightsService != null) {
        applicationInsightsService.logEvent({
          name: 'AppReload'
        });
      }
      window.location.reload();
      return;
    }

    if (applicationInsightsService != null) {
      applicationInsightsService.logException({
        exception: error
      });
    }

    console.error(error);
  }
}
